import React, {useEffect, useState, useRef} from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator.jsx";
import PdfPng from '../../Assets/Pdf.png';
import { ConfigurationApiBlobSasUri,ConfigurationApiDatasourceInfo } from "../../ExternalApi/ConfigurationApi"
import { IsEmptyString, UploadFileWithProgress } from "../GeneralFunctions.jsx"

//This datasource will work with the cloud-only DatasourceBlobFile

const DatasourceExcelFileExport = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false);
    const [mError, SetError] = useState("")
    const [mProgressMessage, SetProgressMessage] = useState("")
    const [mFilename, SetFilename] = useState("No file chosen");
    const [mSheets, SetSheets] = useState([]);

    const mFileInputRef = useRef(null)

    useEffect(() => {
        SetReady()
      }, []); 
      
    const UpdateDatasourceSetting = (aIdentifier, aValue) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aValue
        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(!IsEmptyString(props.IntegrationSettings.DatasourceSettings.BlobName)
            && !IsEmptyString(props.IntegrationSettings.DatasourceSettings.Extension)
            && !IsEmptyString(props.IntegrationSettings.DatasourceSettings.Sheet))
    }
    
    const OnFileChange = async (evt) => 
    {        
        SetError("")
        UpdateDatasourceSetting("BlobName","")
        UpdateDatasourceSetting("Extension","")
        UpdateDatasourceSetting("Sheet","")

        const SelectedFile = evt.target.files[0]

        SetFilename(SelectedFile ? SelectedFile.name : "No file chosen")
        if (!SelectedFile) 
        {
            return
        }

        //Get a secure temporary upload URL
        const BlobSasUriRecord = await ConfigurationApiBlobSasUri(props.SecurityToken);
        if (!BlobSasUriRecord) 
        {
            SetError("Failed to retrieve secure upload link")
            return
        }

        try
        {
            //Use the secure upload URL to upload the file            
            SetProgressMessage("Uploading file");
            await UploadFileWithProgress(SelectedFile, BlobSasUriRecord.Uri, SetProgressMessage)    
            UpdateDatasourceSetting("BlobName",BlobSasUriRecord.BlobName)
            UpdateDatasourceSetting("Extension",SelectedFile.name.endsWith(".xlsx") ? ".xlsx" : ".xls")

            SetProgressMessage("Retrieving excel sheets")
            try
            {
                const result = await ConfigurationApiDatasourceInfo(props.SecurityToken, props.IntegrationSettings.DatasourceType, "Sheets", props.IntegrationSettings.DatasourceSettings)
                if (result.status === 200)
                {
                    try { props.IntegrationSettings.DatasourceSettings.Sheet = result.data.Info[0] } catch {}
                    SetSheets(result.data.Info) 
                    SetProgressMessage("")
                    SetReady()
                }
                else
                {
                    SetError("Failed to request excel sheets")
                }
            }
            catch (ex)
            {
                SetError("Failed to request excel sheets. Error=" + ex.Message)
            }
        }
        catch (ex)
        {
            SetError("Failed to upload file. Error=" + ex.Message)
        }        
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    return (
        <div className="scriptitembody">            
            <input ref={mFileInputRef} type="file" accept=".xls,.xlsx" style={{ display: 'none' }} onChange={OnFileChange}/> 
            <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => mFileInputRef.current?.click()}>{Translate("Choose file")}</Button> <span style={{ marginLeft: "6px"}}>{mFilename}</span>
            {mSheets.length > 0 ? <div>
                <div className="wizardfieldname">{Translate("Sheet").toUpperCase()} <span className="redtext">*</span></div>
                <div className="wizardfieldvalue">
                    <select name="Region" value={props.IntegrationSettings.DatasourceSettings.Sheet} onChange={evt => UpdateDatasourceSetting("Sheet",evt.target.value)} className="wizardinputfield">
                        {mSheets.map((sheet, index) => <option key={"sheet" + index} value={sheet}>{sheet}</option>)}
                    </select>
                </div>
            </div> : <></>}
            {!IsEmptyString(mError) ? <>
                <br/>
                <span className="errortext">{mError}</span>
            </> : 
            (!IsEmptyString(mProgressMessage) ? <>
                <br/>
                <span style={{ color: "green"}}>{mProgressMessage}</span>
            </> : <></>)}
        </div>
    );
}

DatasourceExcelFileExport.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceExcelFileExport